import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';

import { restoreService } from '../../api';

export const useMutationRestoreService = () => {
  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();
  const { t } = useTranslation();

  return useMutation(restoreService, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATION_SERVICES);

      successToast(t('Item successfully restored'));
    },
    onError: () => errorToast(),
  });
};
